
<script lang="ts">
  import AutomationMerusCase from './AutomationMerusCase.svelte';
  import AutomationFileVine from './AutomationFileVine.svelte';
  import FileVineDashboard from './FileVineDashboard.svelte';
  import MerusCaseDashboard from './MerusCaseDashboard.svelte';
  import { createEventDispatcher } from 'svelte';
    import AutomationFluentCase from './AutomationFluentCase.svelte';
    import AutomationMicrosoftSharepoint from './AutomationMicrosoftSharepoint.svelte';
    import { AutomationSetting } from '../../typesTs';

  const dispatch = createEventDispatcher();
  export let user;
  export let fluentCaseToken;
  export let merusCaseEnabled;
  export let fileVineEnabled;
  export let fluentCaseEnabled;
  export let microsoftSharepointTenantId;



  let activeDashboard:AutomationSetting|null = null; 

  const selectDashboard = (dashboard: AutomationSetting|null):void => {
    activeDashboard = dashboard;
  };
  
  export let tutorialStep:number = 0;

  $: {
    if (tutorialStep === 303) {
      setTimeout(() => {
        selectDashboard(AutomationSetting.Notyfy);
      }, 100);
    }

    if (tutorialStep === 300) {
      selectDashboard(null)
    }
  }
</script>

<div class="automation {!activeDashboard ? 'automation--grid' : ''}">
  <!-- {#if activeDashboard === AutomationSetting.FileVine}
    <FileVineDashboard on:close={() => selectDashboard(null)} on:forceClose={() => dispatch('close')} />
  {:else if activeDashboard === AutomationSetting.MerusCase}
    <MerusCaseDashboard on:close={() => selectDashboard(null)} on:forceClose={() => dispatch('close')} />
  {:else if activeDashboard === AutomationSetting.FluentCase}
  <MerusCaseDashboard on:close={() => selectDashboard(null)} on:forceClose={() => dispatch('close')} />
  {:else}  -->
    <div class="automation-row">
      <AutomationMerusCase bind:user={user} bind:merusCaseEnabled={merusCaseEnabled} tutorialStep={tutorialStep} on:open={() => selectDashboard(AutomationSetting.MerusCase)} />
      <AutomationFileVine bind:user={user} bind:fileVineEnabled={fileVineEnabled} on:open={() => selectDashboard(AutomationSetting.FileVine)} />
      <AutomationFluentCase bind:user={user} bind:fluentCaseToken={fluentCaseToken} bind:fluentCaseEnabled={fluentCaseEnabled} on:open={() => selectDashboard(AutomationSetting.FluentCase)} />
    </div>
    <div class="automation-row">
      <AutomationMicrosoftSharepoint bind:user={user} bind:microsoftSharepointTenantId={microsoftSharepointTenantId} on:open={() => dispatch('open')} />
    </div>
  <!-- {/if} -->

</div>

<style lang="scss" scoped>
  .automation {
    width: 100%;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    padding: 5px;

    &--grid {
      display: flex;
      flex-direction: column;
      gap: 20px;
    }
  }

  .automation-row {
    display: grid;
    grid-gap: 20px;
    grid-template-columns: repeat(3, 1fr);
    justify-items: center;
    align-items: center;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }

  @media (max-width: 767px) {
    .automation {
      padding: 4px 0;
      max-width: 100%;
      overflow-x: hidden;
    }

    .automation-row {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      grid-gap: 10px;
      justify-items: center;
    }

    .automation-row :global(.automation-item) {
      max-width: 148px;
      width: 100%;
      box-sizing: border-box;
      padding: 18px 8px 14px;
    }
  }
</style>
